import React, { useEffect, useState } from "react";
import { FaUsers, FaPhoneAlt } from "react-icons/fa"; // Icons for admissions and contacts
import SummaryApi from "../common";
const Dashboard = () => {
  const [counts, setCounts] = useState({
    total_admissions: 0,
    today_admissions: 0,
    total_contacts: 0,
    today_contacts: 0,
  });
  // Fetch data on component mount
  useEffect(() => {
    fetch(SummaryApi.getCounts.url)
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          setCounts(data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching counts:", error);
      });
  }, []);
  return (
    <div>
      <h2 className="text-3xl font-bold text-center mb-8">Dashboard</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 p-6">
        {/* Total Admissions Card */}
        <a href="/admin-panel/admission-report">
          <div className="card bg-white p-6 rounded-lg shadow-md flex items-center justify-between hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
            <div>
              <h3 className="text-xl font-semibold text-gray-800">
                Total Admissions
              </h3>
              <p className="text-3xl font-bold text-blue-600">
                {counts.total_admissions}
              </p>
            </div>
            <div className="text-4xl text-blue-600">
              <FaUsers />
            </div>
          </div>
        </a>
        {/* <a href="/admin-panel/admission-report"> */}
          {/* Today's Admissions Card */}
          <div className="card bg-white p-6 rounded-lg shadow-md flex items-center justify-between hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
            <div>
              <h3 className="text-xl font-semibold text-gray-800">
                Today's Admissions
              </h3>
              <p className="text-3xl font-bold text-green-600">
                {counts.today_admissions}
              </p>
            </div>
            <div className="text-4xl text-green-600">
              <FaUsers />
            </div>
          </div>
        {/* </a> */}
        <a href="/admin-panel/contact-report">
          {/* Total Contacts Card */}
          <div className="card bg-white p-6 rounded-lg shadow-md flex items-center justify-between hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
            <div>
              <h3 className="text-xl font-semibold text-gray-800">
                Total Contacts
              </h3>
              <p className="text-3xl font-bold text-blue-600">
                {counts.total_contacts}
              </p>
            </div>
            <div className="text-4xl text-blue-600">
              <FaPhoneAlt />
            </div>
          </div>
        </a>
        {/* <a href="/admin-panel/contact-report"> */}
          <div className="card bg-white p-6 rounded-lg shadow-md flex items-center justify-between hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
            <div>
              <h3 className="text-xl font-semibold text-gray-800">
                Today's Contacts
              </h3>
              <p className="text-3xl font-bold text-green-600">
                {counts.today_contacts}
              </p>
            </div>
            <div className="text-4xl text-green-600">
              <FaPhoneAlt />
            </div>
          </div>
        {/* </a> */}
        <a href="/admin-panel/newspanel">
          <div className="card bg-white p-6 rounded-lg shadow-md flex items-center justify-between hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
            <div>
              <h3 className="text-xl font-semibold text-gray-800">
                Total news
              </h3>
              <p className="text-3xl font-bold text-blue-600">
                {counts.total_news}
              </p>
            </div>
            <div className="text-4xl text-blue-600">
              <FaPhoneAlt />
            </div>
          </div>
        </a>
        {/* <a href="/admin-panel/newspanel"> */}
          {/* Today's news Card */}
          <div className="card bg-white p-6 rounded-lg shadow-md flex items-center justify-between hover:scale-105 hover:shadow-xl transition-all duration-300 ease-in-out">
            <div>
              <h3 className="text-xl font-semibold text-gray-800">
                Today's news
              </h3>
              <p className="text-3xl font-bold text-green-600">
                {counts.today_news}
              </p>
            </div>
            <div className="text-4xl text-green-600">
              <FaPhoneAlt />
            </div>
          </div>
        {/* </a> */}
      </div>
      
    </div>
  );
};
export default Dashboard;